import * as React from "react";
const SvgSubmit = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 20L3 4L22 12L3 20ZM5 17L16.85 12L5 7L5 10.5L11 12L5 13.5L5 17Z" }));
export default SvgSubmit;
